import { trackingConst } from "../../../../constants";
import { useAnalytics } from "../../../../utils/analytics";
import * as Types from "../../types";
import { openSubMenuAndToggleUI, keyboardEnterOrSpaceClick } from "../../utils";
import { SecondaryNavLink } from "./index";

//Render secondary navigation link without sub navigation
const SecondaryNavWithOutSubNav = ({
  menu,
  isSmall,
  isIntermediate,
  toggleSecondary,
  setToggleSecondary,
  openSecondarySubMenu,
  setIsMainMenuCollapsed,
  setShowSubMenu,
}: {
  menu: Types.SubItem;
  isSmall: boolean;
  isIntermediate: boolean;
  toggleSecondary: boolean;
  setToggleSecondary: (toggleCollapsedMenu: boolean) => void;
  openSecondarySubMenu: Types.OpenMenuFunction;
  setIsMainMenuCollapsed: (toggleSecondary: boolean) => void;
  setShowSubMenu: (toggleSecondary: boolean) => void;
}) => {
  const analytics = useAnalytics();

  return (
    <a
      onKeyDown={(event) => {
        keyboardEnterOrSpaceClick(event, () =>
          openSubMenuAndToggleUI(
            isSmall,
            setToggleSecondary,
            toggleSecondary,
            openSecondarySubMenu,
            menu,
            event,
            isIntermediate,
            setIsMainMenuCollapsed,
            setShowSubMenu,
          ),
        );

        analytics.track(trackingConst.events.navigationClicked, {
          state: menu.href,
          context: trackingConst.contexts.appshell,
        });
      }}
      onClick={(event) => {
        openSubMenuAndToggleUI(
          isSmall,
          setToggleSecondary,
          toggleSecondary,
          openSecondarySubMenu,
          menu,
          event,
          isIntermediate,
          setIsMainMenuCollapsed,
          setShowSubMenu,
        );

        analytics.track(trackingConst.events.navigationClicked, {
          state: menu.href,
          context: trackingConst.contexts.appshell,
        });
      }}
      href={menu.href ? menu.href : null}
      tabIndex={0}
    >
      <SecondaryNavLink menu={menu} isSmall={isSmall} toggleSecondary={toggleSecondary} />
    </a>
  );
};

export default SecondaryNavWithOutSubNav;
